import { Component, OnInit, Renderer2, ElementRef, ViewChild , OnDestroy} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { UserService } from '../user.service';

@Component({
  selector: 'echexpayment-setpassword',
  templateUrl: './setpassword.component.html',
  styleUrls: ['./setpassword.component.css']
})
export class SetpasswordComponent implements OnInit, OnDestroy {

	busy:Subscription;
	public setPassword: any = {};
	public mask: Array<string | RegExp>;
	public set_password: boolean = false;
	public resetpasswordEmail : string;
	public invalidEmail: boolean = false;
	public validationCountry_code: boolean = false;
	public validationPhone: boolean = false;
	public setPassBox : boolean=false;
	public confirm_password : boolean=false;
	public id : string;
	public match :  boolean=false;
	@ViewChild('submitButton') submitButton: ElementRef;

	constructor(private userService: UserService,private elementRef: ElementRef,  private renderer: Renderer2, private router: Router,  private toastr: ToastrService, private  route: ActivatedRoute){
		this.mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
	}

	ngOnDestroy() {
		this.toastr.clear();
	}

	ngOnInit() {
		this.checkUserToken();
		this.setPassword.country_code = "+1";
	}
	
	ngAfterViewInit() {
		setTimeout(() => {
			const businessNameElement = document.querySelector('#initial_focus') as HTMLInputElement;
			if (businessNameElement) {
			  this.renderer.selectRootElement(businessNameElement).focus();
			}
		  }, 0); 
	}

	// Check User token valid or not?
	checkUserToken(){
		let params: any = this.route.snapshot.params;
		let param_data = {
		  user_token:params.user_token,
		}
		let responseData = <any>{};
        this.busy = this.userService.checkUserInfo(param_data).subscribe(
           response => {
		       responseData = response;
			   if(responseData.status == 'success'){
					this.setPassBox = true;
					this.id = responseData.data._id;
			   } else {
					this.toastr.error(responseData.message, 'Failed!');
			   }
           },
           error => {
			this.setPassBox = false;
			responseData = error;
			this.toastr.error(responseData.error.message, 'Failed!');
           }
        );
	}
	
	eventHandler(){
      this.set_password = false;
      this.confirm_password = false;
      this.validationCountry_code = false;
      this.validationPhone = false;
	  this.match = false;
    }
	
	togglePasswordVisibility(inputName: string) {
		const passwordInput = document.querySelector(`input[name="${inputName}"]`);
		const passwordToggle = passwordInput.nextElementSibling.querySelector('i');
	  
		if (passwordInput.getAttribute('type') === 'password') {
		  passwordInput.setAttribute('type', 'text');
		  passwordToggle.classList.remove('fa-eye');
		  passwordToggle.classList.add('fa-eye-slash');
		} else {
		  passwordInput.setAttribute('type', 'password');
		  passwordToggle.classList.remove('fa-eye-slash');
		  passwordToggle.classList.add('fa-eye');
		}
	  }
	// Set password
    setUserPassword(data) {
		this.focusFirstInvalidControlPlus();   //focus field
		if(data.valid) {
			this.set_password = false;
			this.confirm_password = false;
			this.validationCountry_code = false;
			this.validationPhone = false;
			let model = data.value;
			

			if(typeof model.country_code === 'undefined'  || model.country_code === null || model.country_code === ''){
				this.validationCountry_code = true;
				return false;
			}

			if(typeof model.phone === 'undefined'  || model.phone === null || model.phone === ''){
				this.validationPhone = true;
				return false;
			}

			if(typeof model.password === 'undefined'  || model.password === null || model.password === ''){
				this.set_password = true;
				return false;
			}

			if(typeof model.confirm_password === 'undefined'  || model.confirm_password === null || model.confirm_password === ''){
				this.confirm_password = true;
				return false;
			}

			if(model.password != model.confirm_password){
				this.match = true;
				return false;
			}

			model.id = this.id;
			let responseData = <any>{};
			this.busy = this.userService.setPasswordApi(model).subscribe(
				response => {
					responseData = response;
					this.router.navigate(['/login']);
					this.toastr.success(responseData.message, 'Success!');
				},
				error => {
					responseData = error;
					this.toastr.error(responseData.error.message, 'Failed!');
				}
			);
				
		}
	}

	  // + country code in phone field
	  validateInput(event: any): void {
		const inputValue = event.target.value;
		const firstChar = inputValue.charAt(0);
		const keyCode = event.keyCode || event.which;
	  
		// Allow only numeric digits (0-9) and backspace/delete keys
		if (keyCode < 48 || keyCode > 57) {
		  event.preventDefault();
		}
		
		// Limit the input length to 4 characters
		if (inputValue.length >= 4 && keyCode !== 8 && keyCode !== 46) {
		  event.preventDefault();
		}
		
		// Make the first character read-only "+"
		if (inputValue.length === 0) {
		  event.target.value = "+";
		}
	  }
	  
	  handleInputChange(event: any): void {
		const inputValue = event.target.value;
		const firstChar = inputValue.charAt(0);
	  
		// If the input value is empty or contains non-numeric characters, reset the input value with "+"
		if (!inputValue || !(/^\+\d*$/.test(inputValue))) {
		  event.target.value = "+";
		}
	  }
	  // End + country code in phone field

	  //ERROR FOCUS
	  focusFirstInvalidControlPlus(): void {
		const firstElementWithErrors: HTMLElement = this.elementRef.nativeElement.querySelector(`form .ng-invalid`);
		if (firstElementWithErrors) {
			firstElementWithErrors.focus();
		}
	  }
	  //END ERROR FOCUS



	  //Enter Key
	  moveNext(nextInput: HTMLInputElement, checkbox) {
		if(checkbox === 2){
		  const saveButton = document.getElementById('submitButton') as HTMLElement;
		  if (saveButton) {
			saveButton.focus();
			saveButton.click();
		  }
		} else{
		  nextInput && nextInput.focus();
		}
	  }

	  //Password validation
	  containsUppercase(value: string): boolean {
		return /[A-Z]/.test(value);
	  }
	  
	  containsLowercase(value: string): boolean {
		return /[a-z]/.test(value);
	  }
	  
	  containsDigit(value: string): boolean {
		return /\d/.test(value);
	  }
	  
	  containsSpecialCharacter(value: string): boolean {
		return /[!@#$%^&*]/.test(value);
	  }
}



// WEBPACK FOOTER //
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/setpassword/setpassword.component.ts